import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import InsightTaxReform from "@/pages/InsightTaxReform";
import InsightCompliance from "@/pages/InsightCompliance";
import InsightMarketEntry from "@/pages/InsightMarketEntry";
import Careers from "@/pages/Careers";
import Whitepapers from "@/pages/Whitepapers";
import AdminLogin from "@/pages/AdminLogin";
import AdminContracts from "@/pages/AdminContracts";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/insights/tax-reform" element={<InsightTaxReform />} />
        <Route path="/insights/compliance-mistakes" element={<InsightCompliance />} />
        <Route path="/insights/market-entry" element={<InsightMarketEntry />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/whitepapers" element={<Whitepapers />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/contracts" element={<AdminContracts />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
